export default function ({ $auth, $cookies, redirect }) {
  if ($auth.loggedIn) {
    const afterLoginRedirect = $cookies.get('afterLoginRedirect');
    $cookies.set('afterLoginRedirect', '');
    if (afterLoginRedirect && afterLoginRedirect != '') {
      return redirect(afterLoginRedirect);
    }
  }
}
